import { render, staticRenderFns } from "./ConfigPermisses.vue?vue&type=template&id=7a41bb8c"
import script from "./ConfigPermisses.vue?vue&type=script&lang=js"
export * from "./ConfigPermisses.vue?vue&type=script&lang=js"
import style0 from "./ConfigPermisses.vue?vue&type=style&index=0&id=7a41bb8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports